/**
 * Brand colours that aren't available from the @bb-ui theme palette.
 *
 * The dark theme's own `background.default` is onyx (#262626), a neutral grey.
 * Blackboard branding calls for a dark green ground instead, so the full-window
 * surfaces below override it. Keep this in sync with the `theme-color` meta tag
 * in public/index.html.
 */

/** Dark-theme page background. Overrides @bb-ui's onyx (#262626). */
export const backgroundDark = '#172622';

/** Blackboard logo colour on light surfaces. */
export const BLACKBOARD_GREEN = '#1D5245';

export default { backgroundDark, BLACKBOARD_GREEN };
